module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfl-has-label"
  }, [_c('label', {
    staticClass: "vfl-label",
    class: _vm.classObject,
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v("\n    " + _vm._s(_vm.floatLabel) + "\n  ")]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b55795f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-float-label/components/FloatLabel.vue
// module id = 672
// module chunks = 5